import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, ValidationError } from '@formspree/react';
import './ContactForm.css'; // Optional: your styling

const ContactForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  
  // Initialize the form hook with your Formspree form ID
  const [state, handleSubmit] = useForm('mjkrpdkr');

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <section id="contact" className="contact-section">
      <h2>{t('contact.title')}</h2>
      <h3 className="contact-call">{t('contact.call')}</h3>
      <h4 className="contact-phone">{" +351  960-152-719"}</h4>
      <h3 className="contact-subtitle">{t('contact.subtitle')}</h3>

      {/* Conditionally render the form or the success message */}
      {state.succeeded ? (
        <div className="thank-you-container">
          <br /> {/* Line break above the success message */}
          <p className="thank-you-message">{t('contact.thankYouMessage')}</p> 
        </div>
      ) : (
        <form onSubmit={(e) => handleSubmit(e)} className="contact-form">
          <input
            type="text"
            name="name"
            placeholder={t('contact.name')}
            value={formData.name}
            onChange={handleChange}
            required
          />
          <ValidationError 
            prefix="Name" 
            field="name"
            errors={state.errors}
          />

          <input
            type="email"
            name="email"
            placeholder={t('contact.email')}
            value={formData.email}
            onChange={handleChange}
            required
          />
          <ValidationError 
            prefix="Email" 
            field="email"
            errors={state.errors}
          />

          <textarea
            id="message"
            name="message"
            placeholder={t('contact.message')}
            value={formData.message}
            onChange={handleChange}
            required
          />
          <ValidationError 
            prefix="Message" 
            field="message"
            errors={state.errors}
          />
          
          <button type="submit" disabled={state.submitting}>{t('contact.send')}</button>
        </form>
      )}

      {/* If there are general errors in the form submission */}
      {state.errors && state.errors.length > 0 && !state.succeeded && (
        <div className="form-status error">
          {t('contact.error')}
        </div>
      )}
    </section>
  );
};

export default ContactForm;
